import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Assessment } from 'src/app/models/assessment';
import { AssessmentService } from 'src/app/services/assessment.service';
import { UnionDomain } from 'src/app/services/union.domain';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-multiple-assessment-create',
  templateUrl: './multiple-assessment-create.component.html',
  styleUrls: ['./multiple-assessment-create.component.scss'],
})
export class MultipleAssessmentCreateComponent {
  $subscriptions: Subscription[] = [];
  ExcelData: any[] = [];
  fileName: any = 'Samplesheet.xlsx';

  constructor(
    private assessmentService: AssessmentService,
    private toastr: ToastrService,
    private unionDomain: UnionDomain
  ) {}

  ngOnInit(): void {
    this.ExcelData = [];
    this.fileName = 'Samplesheet.xlsx';
  }

  ngOnDestroy(): void {
    this.$subscriptions.forEach((s) => s.unsubscribe());
  }

  ReadExcel(event: any) {
    let file = event.target.files[0];
    let fileReader = new FileReader();
    fileReader.readAsBinaryString(file);
    fileReader.onload = (e) => {
      var workBook = XLSX.read(fileReader.result, { type: 'binary' });
      var sheetNames = workBook.SheetNames;
      this.ExcelData = XLSX.utils.sheet_to_json(workBook.Sheets[sheetNames[0]]);
      // console.log(this.ExcelData);
    };
  }

  exportTableToExcel() {
    let element = document.getElementById('tableId');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, this.fileName);
  }

  uploadToDatabase = (): void => {
    if (this.ExcelData.length == 0 || this.ExcelData == null) {
      this.ExcelData = [];
      this.toastr.error(`ফাইল নির্ধারন করুন।`);
      return;
    }
    for (let index = 0; index < this.ExcelData.length; index++) {
      this.ExcelData[index].holding_number =
        this.unionDomain.convertEnglishHoldingNumberToBanglaHoldingNumber(
          this.ExcelData[index].holding_number.toString()
        );
    }
    // console.log("ami asi")
    this.$subscriptions.push(
      this.assessmentService.createMultipleAssesment(this.ExcelData).subscribe({
        next: (res) => {
          this.toastr.success(res.message);
          this.ngOnInit();
        },
        error: (err) => {
          this.toastr.error(err.error.message);
        },
      })
    );
  };
}
